<template>
  <a v-if="isAdmin" :href="destinationUrl" target="_blank">
    <button class="btn request-for-btn" type="button" v-text="buttonText" />
  </a>
  <router-link v-else :to="destinationUrl">
    <button
      class="btn request-for-btn"
      v-text="title"
    />
  </router-link>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    /**
     * Gomb cime
     */
    title: {
      type: [String, null],
      required: true,
    },
    /**
     * Gomb linkje
     */
    link: {
      type: [String, null],
      required: true,
    },
  },
  data() {
    return {
      /**
       * Admin oldalon nézzük-e a gombot
       *
       * @type {Boolean}
       */
      isAdmin: false,
    }
  },
  computed: {
    /**
     * gomb szövege
     * ha van custom akkor az
     *
     * @return {string}
     */
    buttonText() {
      return this.title === null ? '' : this.title
    },
    /**
     * link to értéke.
     *
     * @return {string}
     */
    destinationUrl() {
      let path = ''
      if (this.isAdmin) {
        path = window.location.origin
      }
      if (this.link !== null) {
        path += this.link
      }
      return path
    },
  },
  created() {
    this.isAdmin = window.location.pathname.includes('/admin')
  },
}
</script>

<style lang="scss" scoped>
.request-for-btn {
  //display: flex;
  height: 2.5rem;
  padding: 0.625rem 0.938rem;
  gap: 0.625rem;
  border-radius: 0.25rem;
  border: 0.063rem solid #000;
  background: #fff;
  text-transform: uppercase;
  color: #000;
  text-align: center;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.request-for-btn:hover, .request-for-btn:focus {
  color: #fff;
  background: var(--main-theme-color);
  border-color: transparent;
}
</style>
